const getters = {
  // 生成有权限的数组
  authItem(state) {
    let JGList = JSON.parse(JSON.stringify(state.leftList))
    let fundsLeft = JGList[3]
    let newFundLeft = []
    if (!fundsLeft) return
    for (let item of fundsLeft.children) {
      for (let authItem of state.fundsAuth) {
        let label = authItem.pageName
        if (label === '充值码支付') {
          label = '商城支付'
        }
        //&&!(authItem.isFirst=='0' && authItem.pageName=='网上支付')
        if (
          new RegExp(label).test(item.meta.title) &&
          authItem.pageStatus === '0' &&
          ((authItem.isFirst == '1' && authItem.isFirstStatus == '0') || (authItem.isFirst == '0' && authItem.notFirstStatus == '0'))
        ) {
          newFundLeft.push(item.meta.title)
        }
      }
      if (item.meta.title === 'menu.widraw' || item.meta.title === 'menu.fdet' || item.meta.title === 'menu.injects') {
        newFundLeft.push(item.meta.title)
      }
    }
    return newFundLeft
  },
  // 左侧
  currenLeftList(state) {
    let JGList = JSON.parse(JSON.stringify(state.leftList))
    JGList[5] = '' //隐藏活动中心
    JGList[4] = ''

    if (state.listType != 0) {
      if (state.userRole != '2') {
        //不是机构客户 隐藏机构功能
        JGList[1] = ''
       
      }
      if (state.userRole == '2' || state.userRole == '3') {
        delete JGList[2].children[2]
      }
      // 已经升级账户 不显示升级入口
      // if (state.userRole != '4') {
      //   JGList[6] = ''
      // }

      // 不是直客则不显示首充活动  是直客则不显示原油
      // if (state.userRole != '4' && state.userRole != '5') {
      //   JGList[7] = ''
      // } else {
      //   console.log(JGList[5])
      //   JGList[5].children.splice(1, 1)
      // }
      //暂时屏蔽之前的邀请好友 首充活动
      JGList[7] = ''
      JGList[8] = ''
      return JGList
    } else {
      let newList = []
      state.leftList.forEach((item, index) => {
        if (index == 0 || index == 6) {
          //|| index == 2 账户资料 模拟账号没有实名认证 修改密码 不显示 || index == 3  资金管理没有可操作菜单  暂时屏蔽
          newList.push(item)
        } else {
          newList.push('')
        }
      })
      //暂时屏蔽邀请好友
      //newList[6] = ''
      return newList
    }
  },
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js